import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { TicketComposerStep } from '../core/_models';

type Props = {
  step: TicketComposerStep;
  formId: string;
  isSending: boolean;
  onCancel: () => void;
  onBack: () => void;
};

const TicketComposerFooter = ({ step, formId, isSending, onCancel, onBack }: Props) => {
  if (step === TicketComposerStep.SUBJECT) {
    return (
      <Modal.Footer>
        <Button className="text-gray-600" variant="secondary" onClick={onCancel}>
          Cancelar
        </Button>
      </Modal.Footer>
    );
  }

  return (
    <Modal.Footer className="justify-content-between">
      <Button className="text-gray-600" variant="secondary" onClick={onBack}>
        Voltar
      </Button>
      <Button disabled={isSending} form={formId} type="submit" variant="primary">
        Abrir chamado
      </Button>
    </Modal.Footer>
  );
};

export default TicketComposerFooter;
